"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _themeUi = require("theme-ui");

var _Box = _interopRequireDefault(require("../../../Layout/Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx jsx */
var defaultProps = {
  overlay: false
};

var Overlay = function Overlay(props) {
  return (0, _themeUi.jsx)(_Box.default, (0, _tslib.__assign)({
    sx: {
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      backgroundColor: props.overlay ? 'rgba(0, 0, 0, 0.6)' : 'transparent'
    }
  }, props));
};

Overlay.displayName = 'LayerOverlay';
Overlay.defaultProps = defaultProps;
var _default = Overlay;
exports.default = _default;